import { ActionGroupTypes, ActionStatusTypes } from "../../../enum/ActionStatusTypes";
import * as logger from "../../../logger";
import { getNodeById } from "../../../nodeSelector";
import * as nodeUtils from "../../../utils/nodeUtils";
import * as pathUtils from "../../../utils/pathUtils";
import * as systemUtils from "../../../utils/systemUtils";
import { ACTION_PREFIX_CHOICE } from "./abstract/choiceAbstract";

const _action = `${ACTION_PREFIX_CHOICE}_update_value`;
const _header = `Update value`;

export const updateChoiceValue = (root, id, value) => {
  const _payload = updateChoiceValueLogic(root, id, value);

  logger.logAction(_action, _payload, ACTION_PREFIX_CHOICE);

  return { root, info: _payload };
};

//--------------------------------------------------------------------------------

export const updateChoiceValueLogic = (root, id, value) => {
  const { data: _node, index: _index } = getNodeById(root, id);
  if (!_node) {
    throw new Error("Choice to update not found");
  }
  const { data: _nodeParent } = getNodeById(root, pathUtils.getIdParent(id));
  if (!_nodeParent) {
    throw new Error("Parent node not found");
  }

  const _nodeBackup = systemUtils.createDeepCopy(_node);

  nodeUtils.setValue(_node, value);

  return generatePayload(_nodeBackup, _index, _nodeParent, nodeUtils.getValue(_node));
};

//--------------------------------------------------------------------------------

const generatePayload = (node, index, nodeParent, valueAfter) => {
  return {
    group: ActionGroupTypes.UPDATE,
    status: ActionStatusTypes.SUCCESS,
    action: _action,
    time: systemUtils.getTimestamp(),
    header: _header,
    description: generatePayloadDescription(node),
    node: node,
    uuid: nodeUtils.getUUID(node),
    uuidParent: nodeUtils.getUUID(nodeParent),
    index: index,
    valueBefore: nodeUtils.getValue(node),
    valueAfter: valueAfter,
  };
};

const generatePayloadDescription = (node) => {

  return `Update the value of '${nodeUtils.getName(node)}'.`;
}